/* eslint-disable react/no-unused-prop-types */
import React from 'react'
import styled from 'styled-components'
import {
  ChartIcon,
  Flex,
  Heading,
  HistoryIcon,
  IconButton,
  NotificationDot,
  Text,
  useModal,
  ChartDisableIcon,
} from '@pancakeswap/uikit'
import GlobalSettings from 'components/Menu/GlobalSettings'
import { useExpertModeManager } from 'state/user/hooks'
import TransactionsModal from '../../../components/App/Transactions/TransactionsModal';

interface Props {
  title: string
  subtitle: string
  noConfig?: boolean
  setIsChartDisplayed?: React.Dispatch<React.SetStateAction<boolean>>
  isChartDisplayed?: boolean
}

const CurrencyInputContainer = styled(Flex)`
  align-items: center;
  padding: 24px;
  width: 100%;
  border-bottom: 1px solid ${({ theme }) => theme.colors.cardBorder};
`

const ColoredIconButton = styled.div`
  display: flex;
  align-items: center;
  color: ${({ theme }) => theme.colors.textSubtle};
`

const CurrencyInputHeader: React.FC<Props> = ({ title, subtitle, setIsChartDisplayed, isChartDisplayed }) => {
  const [expertMode] = useExpertModeManager()
  const toggleChartDisplayed = () => {
    setIsChartDisplayed((currentIsChartDisplayed) => !currentIsChartDisplayed)
  }
  const [onPresentTransactionsModal] = useModal(<TransactionsModal />)

  return (
    <CurrencyInputContainer>
      {setIsChartDisplayed && (
        <ColoredIconButton>
          <IconButton onClick={toggleChartDisplayed} variant="text" scale="sm">
            {isChartDisplayed ? <ChartDisableIcon color="textSubtle" /> : <ChartIcon width="24px" color="textSubtle" />}
          </IconButton>
        </ColoredIconButton>
      )}
      <Flex flexDirection="column" alignItems="center">
        <Heading as="h2" mb="8px">
          {title}
        </Heading>
        <Flex alignItems="center">
          <Text color="textSubtle" fontSize="14px">
            {subtitle}
          </Text>
        </Flex>
      </Flex>
      <Flex>
        <NotificationDot show={expertMode}>
          <GlobalSettings color="textSubtle" mr="0" />
        </NotificationDot>
        <IconButton onClick={onPresentTransactionsModal} variant="text" scale="sm">
          <HistoryIcon color="textSubtle" width="24px" />
        </IconButton>
      </Flex>
    </CurrencyInputContainer>
  )
}

export default CurrencyInputHeader
